import { CampaignType } from 'generated-graphql/types';
import { RecipientsType } from 'modules/campaign-creation/steps/CampaignCreationChooseRecipientsStep';
import { CampaignCreationStep } from 'modules/campaign-creation/stores/CampaignCreationSteps';

export const getRecipentStepNextStep = (
  recipientType: RecipientsType
): CampaignCreationStep => {
  switch (recipientType) {
    case 'everyone':
      return 'CHANNEL';
    case 'specific':
      return 'ANALYSIS_SETUP';
    case 'imported':
      return 'IMPORT_CANDIDATES';
  }
};

export const getRecipentStepPrevStep = (
  recipientType: RecipientsType
): CampaignCreationStep => {
  switch (recipientType) {
    case 'everyone':
      return 'CHOOSE_RECIPIENTS';
    case 'specific':
      return 'ANALYSIS_SETUP';
    case 'imported':
      return 'IMPORT_CANDIDATES';
  }
};

export const getCampaignTypeFromRecipientType = ({
  previousCampaignType,
  recipientType
}: {
  previousCampaignType: CampaignType | null | undefined;
  recipientType: RecipientsType;
}): CampaignType => {
  if (previousCampaignType === CampaignType.EngagementOutreach) {
    return CampaignType.EngagementOutreach;
  }

  if (recipientType === 'everyone') return CampaignType.ApplicantOutreach;

  if (recipientType === 'specific') return CampaignType.ApplicantOutreach;

  return CampaignType.NewCandidateOutreach;
};
